import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const GET_EQUIPMENT_REQUEST = 'Equipment/GET_EQUIPMENT_REQUEST'
const GET_EQUIPMENT_SUCCESS = 'Equipment/GET_EQUIPMENT_SUCCESS'
const GET_EQUIPMENT_FAILURE = 'Equipment/GET_EQUIPMENT_FAILURE'

const GET_EQUIPMENT_SELLER_REQUEST = 'Equipment/GET_EQUIPMENT_SELLER_REQUEST'
const GET_EQUIPMENT_SELLER_SUCCESS = 'Equipment/GET_EQUIPMENT_SELLER_SUCCESS'
const GET_EQUIPMENT_SELLER_FAILURE = 'Equipment/GET_EQUIPMENT_SELLER_FAILURE'

const GET_EQUIPMENT_CATEGORY_REQUEST = 'Equipment/GET_EQUIPMENT_CATEGORY_REQUEST'
const GET_EQUIPMENT_CATEGORY_SUCCESS = 'Equipment/GET_EQUIPMENT_CATEGORY_SUCCESS'
const GET_EQUIPMENT_CATEGORY_FAILURE = 'Equipment/GET_EQUIPMENT_CATEGORY_FAILURE'

const CREATE_EQUIPMENT_REQUEST = 'Equipment/CREATE_EQUIPMENT_REQUEST'
const CREATE_EQUIPMENT_SUCCESS = 'Equipment/CREATE_EQUIPMENT_SUCCESS'
const CREATE_EQUIPMENT_FAILURE = 'Equipment/CREATE_EQUIPMENT_FAILURE'

const DELETE_EQUIPMENT_REQUEST = 'Equipment/DELETE_EQUIPMENT_REQUEST'
const DELETE_EQUIPMENT_SUCCESS = 'Equipment/DELETE_EQUIPMENT_SUCCESS'
const DELETE_EQUIPMENT_FAILURE = 'Equipment/DELETE_EQUIPMENT_FAILURE'

const UPDATE_EQUIPMENT_REQUEST = 'Equipment/UPDATE_EQUIPMENT_REQUEST'
const UPDATE_EQUIPMENT_SUCCESS = 'Equipment/UPDATE_EQUIPMENT_SUCCESS'
const UPDATE_EQUIPMENT_FAILURE = 'Equipment/UPDATE_EQUIPMENT_FAILURE'

const UPDATE_EQUIPMENT_CATEGORY_REQUEST = 'Equipment/UPDATE_EQUIPMENT_CATEGORY_REQUEST'
const UPDATE_EQUIPMENT_CATEGORY_SUCCESS = 'Equipment/UPDATE_EQUIPMENT_CATEGORY_SUCCESS'
const UPDATE_EQUIPMENT_CATEGORY_FAILURE = 'Equipment/UPDATE_EQUIPMENT_CATEGORY_FAILURE'

const CREATE_EQUIPMENT_SUB_CATEGORY_REQUEST = 'Equipment/CREATE_EQUIPMENT_SUB_CATEGORY_REQUEST'
const CREATE_EQUIPMENT_SUB_CATEGORY_SUCCESS = 'Equipment/CREATE_EQUIPMENT_SUB_CATEGORY_SUCCESS'
const CREATE_EQUIPMENT_SUB_CATEGORY_FAILURE = 'Equipment/CREATE_EQUIPMENT_SUB_CATEGORY_FAILURE'

const UPDATE_EQUIPMENT_SUB_CATEGORY_REQUEST = 'Equipment/UPDATE_EQUIPMENT_SUB_CATEGORY_REQUEST'
const UPDATE_EQUIPMENT_SUB_CATEGORY_SUCCESS = 'Equipment/UPDATE_EQUIPMENT_SUB_CATEGORY_SUCCESS'
const UPDATE_EQUIPMENT_SUB_CATEGORY_FAILURE = 'Equipment/UPDATE_EQUIPMENT_SUB_CATEGORY_FAILURE'

const DELETE_EQUIPMENT_SUB_CATEGORY_REQUEST = 'Equipment/DELETE_EQUIPMENT_SUB_CATEGORY_REQUEST'
const DELETE_EQUIPMENT_SUB_CATEGORY_SUCCESS = 'Equipment/DELETE_EQUIPMENT_SUB_CATEGORY_SUCCESS'
const DELETE_EQUIPMENT_SUB_CATEGORY_FAILURE = 'Equipment/DELETE_EQUIPMENT_SUB_CATEGORY_FAILURE'

const CREATE_EQUIPMENT_SELLER_REQUEST = 'Equipment/CREATE_EQUIPMENT_SELLER_REQUEST'
const CREATE_EQUIPMENT_SELLER_SUCCESS = 'Equipment/CREATE_EQUIPMENT_SELLER_SUCCESS'
const CREATE_EQUIPMENT_SELLER_FAILURE = 'Equipment/CREATE_EQUIPMENT_SELLER_FAILURE'

const UPDATE_EQUIPMENT_SELLER_REQUEST = 'Equipment/UPDATE_EQUIPMENT_SELLER_REQUEST'
const UPDATE_EQUIPMENT_SELLER_SUCCESS = 'Equipment/UPDATE_EQUIPMENT_SELLER_SUCCESS'
const UPDATE_EQUIPMENT_SELLER_FAILURE = 'Equipment/UPDATE_EQUIPMENT_SELLER_FAILURE'

const DELETE_EQUIPMENT_SELLER_REQUEST = 'Equipment/DELETE_EQUIPMENT_SELLER_REQUEST'
const DELETE_EQUIPMENT_SELLER_SUCCESS = 'Equipment/DELETE_EQUIPMENT_SELLER_SUCCESS'
const DELETE_EQUIPMENT_SELLER_FAILURE = 'Equipment/DELETE_EQUIPMENT_SELLER_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  equipment: [],
  categories: [],
  seller: []
}

// Default Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_EQUIPMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_EQUIPMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        equipment: action.payload
      }
    case GET_EQUIPMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_EQUIPMENT_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_EQUIPMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        categories: action.payload
      }
    case GET_EQUIPMENT_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case GET_EQUIPMENT_SELLER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case GET_EQUIPMENT_SELLER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        seller: action.payload
      }
    case GET_EQUIPMENT_SELLER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_EQUIPMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_EQUIPMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_EQUIPMENT_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_EQUIPMENT_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_EQUIPMENT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_EQUIPMENT_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_EQUIPMENT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_EQUIPMENT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_EQUIPMENT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_EQUIPMENT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_EQUIPMENT_SUB_CATEGORY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_EQUIPMENT_SUB_CATEGORY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_EQUIPMENT_SUB_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_EQUIPMENT_SELLER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_EQUIPMENT_SELLER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_EQUIPMENT_SELLER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_SELLER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_EQUIPMENT_SELLER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_EQUIPMENT_SELLER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_EQUIPMENT_SELLER_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_EQUIPMENT_SELLER_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_EQUIPMENT_SELLER_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }

}

// Action Creators
export const getEquipment = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_EQUIPMENT_REQUEST
      })

      const response = await API.get(EndPoints.EQUIPMENT + `/all`)
      dispatch({
        type: GET_EQUIPMENT_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_EQUIPMENT_FAILURE
      })
    }
  }
}
export const fetchCategories = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_EQUIPMENT_CATEGORY_REQUEST
      })

      const response = await API.get(EndPoints.EQUIPMENT + `/categoryDetail/all`)
      dispatch({
        type: GET_EQUIPMENT_CATEGORY_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_EQUIPMENT_CATEGORY_FAILURE
      })
    }
  }
}

export const fetchSeller = () => {
  return async (dispatch) => {
    try {
      dispatch({
        type: GET_EQUIPMENT_SELLER_REQUEST
      })

      const response = await API.get(EndPoints.EQUIPMENT + `/seller/all`)
      dispatch({
        type: GET_EQUIPMENT_SELLER_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: GET_EQUIPMENT_SELLER_FAILURE
      })
    }
  }
}

export const createEquipment = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_EQUIPMENT_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.EQUIPMENT + `/createEquipment`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_EQUIPMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_EQUIPMENT_FAILURE
      })
    }
  }
}
export const updateEquipment = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_EQUIPMENT_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.EQUIPMENT + `/updateEquipment`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_EQUIPMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_EQUIPMENT_FAILURE
      })
    }
  }
}
export const deleteEquipment = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_EQUIPMENT_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.EQUIPMENT + `/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_EQUIPMENT_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_EQUIPMENT_FAILURE
      })
    }
  }
}
export const updateCategory = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_EQUIPMENT_CATEGORY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.EQUIPMENT + `/updateCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_EQUIPMENT_CATEGORY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_EQUIPMENT_CATEGORY_FAILURE
      })
    }
  }
}

export const createSubCategory = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_EQUIPMENT_SUB_CATEGORY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.EQUIPMENT + `/createSubCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_EQUIPMENT_SUB_CATEGORY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_EQUIPMENT_SUB_CATEGORY_FAILURE
      })
    }
  }
}
export const updateSubCategory = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_EQUIPMENT_SUB_CATEGORY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.EQUIPMENT + `/updateSubCategory`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_EQUIPMENT_SUB_CATEGORY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_EQUIPMENT_SUB_CATEGORY_FAILURE
      })
    }
  }
}
export const deleteSubCategory = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_EQUIPMENT_SUB_CATEGORY_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.EQUIPMENT + `/subCategory/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_EQUIPMENT_SUB_CATEGORY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_EQUIPMENT_SUB_CATEGORY_FAILURE
      })
    }
  }
}

export const createSeller = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_EQUIPMENT_SELLER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.post(EndPoints.EQUIPMENT + `/createSeller`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: CREATE_EQUIPMENT_SELLER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_EQUIPMENT_SELLER_FAILURE
      })
    }
  }
}
export const updateSeller = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_EQUIPMENT_SELLER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.put(EndPoints.EQUIPMENT + `/updateSeller`, data, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: UPDATE_EQUIPMENT_SELLER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_EQUIPMENT_SELLER_FAILURE
      })
    }
  }
}
export const deleteSeller = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_EQUIPMENT_SELLER_REQUEST
      })
      const token = localStorage.getItem('user-token')
      const authorizationHeader = token ? token : ''
      await API.delete(EndPoints.EQUIPMENT + `/seller/${id}`, {
        headers: {
          Authorization: authorizationHeader
        }
      })
      dispatch({
        type: DELETE_EQUIPMENT_SELLER_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_EQUIPMENT_SELLER_FAILURE
      })
    }
  }
}



